import { logger } from './logger'

/**
 * Visit Type Logic
 * Determines if a user needs a Synchronous (Video/Phone) or Asynchronous (Chat/Form) visit
 */

export const isSyncVisit = (userData) => {
  const {
    state,
    age,
    average_blood_pressure,
    avg_resting_heart_options,
    other_health_conditions_options,
    dq_health_conditions_by_bmi_options,
    other_concerns_options
  } = userData;

  const syncStates = ['CO', 'HI', 'KY', 'MO', 'SC', 'UT', 'AK', 'KS', 'VA', 'AR', 'DC', 'DE', 'MS', 'NM', 'RI', 'WV'];
  const isSyncStateCheck = syncStates.includes(state?.toUpperCase());

  // Helper: Check for old age with serious conditions
  const hasOldAgeSeriousCondition = () => {
    const ageNum = parseInt(age, 10);
    if (isNaN(ageNum)) return false;

    return (
      ageNum >= 65 && ageNum <= 74 &&
      (
        average_blood_pressure === 'high_stage_2' ||
        ['hiv', 'kidney_disease'].some(condition =>
          (other_health_conditions_options || []).includes(condition)
        ) ||
        ['t2_diabetes_no_insulin', 'liver_disease'].some(condition =>
          (dq_health_conditions_by_bmi_options || []).includes(condition)
        )
      )
    );
  };

  // Helper: Check for serious conditions
  const hasSeriousCondition = () => {
    const seriousOtherConditions = ['brain_tumor', 'recent_hospitalization'];
    const seriousBMIConditions = ['coronary_disease', 'heart_failure'];

    return (
      seriousOtherConditions.some(condition =>
        (other_health_conditions_options || []).includes(condition)
      ) ||
      seriousBMIConditions.some(condition =>
        (dq_health_conditions_by_bmi_options || []).includes(condition)
      )
    );
  };

  // Main Logic
  if (
    isSyncStateCheck ||
    hasOldAgeSeriousCondition() ||
    average_blood_pressure === 'high_stage_2' ||
    avg_resting_heart_options === 'fast' ||
    hasSeriousCondition() ||
    (Array.isArray(other_concerns_options) && other_concerns_options.includes('not_sure'))
  ) {
    logger.debug("Visit Type: Sync (Video/Phone)");
    return true;
  } else {
    logger.debug("Visit Type: Async (Form/Chat)");
    return false;
  }
};
